import { render } from "./Index.vue?vue&type=template&id=2c1e9eaa&scoped=true"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2c1e9eaa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1e9eaa"],['__file',"resources/js/modules/product-categorization/components/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c1e9eaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c1e9eaa', __exports__)) {
    api.reload('2c1e9eaa', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=2c1e9eaa&scoped=true", () => {
    api.rerender('2c1e9eaa', render)
  })

}


export default __exports__